import toast from "react-hot-toast";
import useRead from "../useRead";

const useGetComponentsForTemplate = () => {
  const { list, setGetListParams } = useRead({
    url: "salary-components/list",
    initialData: {
      limit: 10,
      pageNo: 0,
    },
    method: "GET",
    onSuccess: () => {},
    onError: (error) => {
      toast.error("Error fetching salary components:" + error?.message);
    },
  });
  const componentsList = list.data?.component_data || [];
  const pagination = list.data?.pagination || {};
  const isListLoading = list.isLoading;

  const handlePageClick = (val) => {
    setGetListParams((prev) => ({
      ...prev,
      pageNo: val.selected,
    }));
  };

  return {
    componentsList,
    pagination,
    isListLoading,
    handlePageClick,
  };
};

export default useGetComponentsForTemplate;
